import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../../Icon/Icon.es.js';

const SelectListNoResults = ({ children, ...props })=>{
    return jsxs("div", {
        className: "select-list-no-results",
        ...props,
        children: [
            jsx(Icon, {
                className: "search-icon",
                name: "SearchCircleOutline",
                size: 20
            }),
            children
        ]
    });
};
SelectListNoResults.displayName = 'SelectList.NoResults';

export { SelectListNoResults };
//# sourceMappingURL=SelectList.NoResults.es.js.map
